export function mapRetailOrder(last_order){
  let order = {}
  order.items_attributes = []
  
  last_order.items.forEach(el => {
    order.items_attributes.push({
      brand_id: el.brand.id,
      brand_name: el.brand.name,
      segment_id: el.segment_id,
      segment_name: el.segment_name,
      product_id: el.product_id, 
      product_name: el.product.name,
      stock_id: el.stock_id,
      sell_price: '0.00',
      sell_price_aux: el.sell_price,
      total_sell_price: parseFloat(el.total_sell_price),
      total_units: '0.00',
      total_units_aux: el.total_units,
      total_units_delivered: '0.00',
      unit_ship: '0.00',
      unit_ship_aux: el.unit_ship,
      total_ship: last_order.kind == 'pickup' && !el.total_ship ? '0.00' : parseFloat(el.total_ship),
      is_delivery: false,
      ref: Math.random()*100 
    })
  })

  order.shipping_attributes = {
    address_id: last_order.shipping?.address_id,
    building_id: last_order.shipping?.building_id,
    building_address: last_order.shipping?.building_address,
    driver_id: null,
    expected_delivery: null,
    is_new_address: false,
    number_assistants: last_order.shipping?.number_assistants,
    problems: null,
    shipping_value: null,
    shipping_value_aux: '0.00',
    truck_id: null,
    whole_address: last_order.shipping?.whole_address,
  }

  order.created_by_name = last_order.created_by_name,
  order.client = last_order.client
  order.client_id = last_order.client_id,
  order.comment = last_order.comment
  order.client_name = last_order.client.name,
  order.is_default_client = false,
  order.kind = last_order.kind,
  order.new_address_attributes = {}
  order.solution = 'retail'
  order.payments = {
    list: last_order.payments.list.map((el) => { return {...el, pix_id: null} }),
    has_cash: last_order.payments.has_cash,
    cash_id: last_order.payments.cash_id,
    cash_idx: last_order.payments.cash_idx,
    cash_idxes: last_order.payments.cash_idxes,
  }

  order.employee_id = last_order.employee_id
  order.manager_id = last_order.manager_id


  return order
}

export default mapRetailOrder